import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';
import PgLogo from '../../assets/pglogo.png';

const Footer = () => {
  const navigate = useNavigate();

  const openReportForm = () => {
    window.open(
      'https://forms.monday.com/forms/badc3b42135a449278c56f5ebe9b88f6?r=euc1',
      'ReportIssue',
      'width=720,height=800,scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=no,status=no'
    );
  };

  const goToSuggestions = () => {
    navigate('/suggestions');
  };

  const SHAREPOINT_URL =
    'https://govmt.sharepoint.com/:f:/r/sites/PG-CentralResourceLibrary/Shared%20Documents/Central%20Resource%20Library?d=w28c2b6bba14c473d8a529e811585135d&csf=1&web=1&e=n9gHkC';

  return (
    <footer className="footer">
      <div className="footer-shell">
        <div className="footer-inner">
          <div className="footer-brand">
            <img src={PgLogo} alt="Project Green" className="footer-logo-img" />
            <p className="footer-tagline">Internal Use Only</p>
          </div>

          {/* Quick Links: heading centered above two 3-item columns */}
          <div className="footer-col footer-quicklinks">
            <h4>Quick Links</h4>
            <div className="footer-quicklinks-grid">
              <ul>
                <li>
                  <a href="https://projectgreenmalta.monday.com/" target="_blank" rel="noopener noreferrer">Monday.com</a>
                </li>
                <li>
                  <a href="https://intranet.projectgreen.mt/qms" target="_blank" rel="noopener noreferrer">QMS</a>
                </li>
                <li>
                  <a href="https://aquadot.projectgreen.mt/efile/login" target="_blank" rel="noopener noreferrer">Aquadot</a>
                </li>
              </ul>
              <ul>
                <li>
                  <a href={SHAREPOINT_URL} target="_blank" rel="noopener noreferrer">Resources</a>
                </li>
                <li>
                  <a href="https://projectgreen.talexiohr.com/dashboard" target="_blank" rel="noopener noreferrer">Talexio</a>
                </li>
                <li>
                  <a href="https://forms.monday.com/forms/53bc467ba120d7c07da9e36500cdbe75?r=euc1" target="_blank" rel="noopener noreferrer">IT Support</a>
                </li>
              </ul>
            </div>
          </div>

          {/* Legal column - sits between Quick Links and Suggestions */}
          <div className="footer-col footer-legal">
            <h4>Legal</h4>
            <ul>
              <li>
                <button onClick={() => navigate('/policy/cookies')}>Cookies Policy</button>
              </li>
            </ul>
          </div>

          <div className="footer-col footer-suggestions">
            <h4>Suggestions</h4>
            <p className="footer-report-desc">
              Have an idea to improve our intranet? Tell us what you&rsquo;d like to see, change, or improve.
              <br />
              Your feedback helps us make the intranet better for everyone.
            </p>
            <button className="footer-report-btn" onClick={goToSuggestions}>
              <span className="footer-btn-label">Open Suggestion Form</span>
            </button>
          </div>

          <div className="footer-col footer-report">
            <h4>Report an issue</h4>
            <p className="footer-report-desc">
              Do you have an issue with the intranet?
              <br />
              Please let us know by submitting the form below.
            </p>
            <button className="footer-report-btn" onClick={openReportForm}>
              <span className="footer-btn-label">Open Report Form</span>
            </button>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Project Green. All rights reserved.
            <span className="footer-separator">&bull;</span>
            This portal is for internal use only.
          </p>
          <p className="footer-credit">
            Designed &amp; Developed by <strong>PG Technology</strong>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;